import React from "react"
import { Link } from "gatsby"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import RetinaImageWrapper from "../../components/RetinaImage"

const BlogPostTemplate = ({ pageContext: { blog, prev, next } }) => {
  return (
    <Layout>
      <SEO
        title={blog.metaTitle || blog.title}
        description={blog.metaDescription || blog.excerpt}
        image={blog.coverImage[0].url}
        jsonSchema={blog.jsonSchema}
      />
      <div className="container blog-single">
        <div className="row">
          <div className="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <Link to={"/blog"} className={"top-items back-to-blog"}>
              Workplace One Blog
            </Link>
            {blog.blogCategory.length > 0 && (
              <span className={"top-items category"}>
                {blog.blogCategory[0].title}
              </span>
            )}
            <h1>{blog.title}</h1>

            {blog.blogAuthor && (
              <span className={"author"}>By {blog.blogAuthor}</span>
            )}

            <RetinaImageWrapper
              image={blog.coverImage[0]}
              retinaImage={blog.coverImageRetina[0]}
              alt={blog.title}
              className={"main-image"}
            />

            <div
              className="blog-body"
              dangerouslySetInnerHTML={{ __html: blog.blogBody }}
            />

            <div className="blog-footer d-flex justify-content-between">
              {prev && (
                <Link to={`/blog/${prev}`} className={"prev"}>
                  Previous
                </Link>
              )}
              {next && (
                <Link to={`/blog/${next}`} className={"next"}>
                  Next Post
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default BlogPostTemplate
